require('./dist/tabs/tabs.css');
